import { Component, computed, model, OnInit, Signal } from '@angular/core';
import { AbstractComponent } from '../../abstract-component';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-vertx',
  imports: [ReactiveFormsModule],
  templateUrl: './vertx.component.html',
  styleUrl: './vertx.component.css'
})
export class VertxComponent extends AbstractComponent implements OnInit {

  eventBusName = new FormControl("Valor inicial")
  externalServiceURL = new FormControl("https://en.wikipedia.org/w/api.php?action=parse&page=Quarkus&format=json&prop=langlinks")
  leerFicheroResource = this.dhrService.vertxLoadFileResource
  leerFicheroResourceValue = computed(() => {
    console.log("Valor de leerFicheroResource:", this.leerFicheroResource.value());
    return this.leerFicheroResource.value();
  });
  leerFicheroGrandeResource = this.dhrService.vertxLoadFileBigResource
  leerFicheroGrandeResourceValue = computed(() => {
    console.log("Valor de leerFicheroGrandeResource:", this.leerFicheroGrandeResource.value());
    return this.leerFicheroGrandeResource.value();
  });
  eventBusResource = model<string>("")
  externalServiceResource = model<string>("")

  ngOnInit(): void {
    // Initialization logic here
  }
  

  constructor() {
    super();

    
  }

  onLeerFichero(): void {
    // Logic to read file
    this.leerFicheroResource.reload()
  }

  onLeerFicheroGrande(): void {
    // Logic to read large file
    this.leerFicheroGrandeResource.reload()
  }
  onBus(): void {
    // Logic to send message to event bus
    this.dhrService.vertxEventBus(this.eventBusName.value!).subscribe({
      next: (response) => {
        console.log('Event bus response:', response);
        this.eventBusResource.set(response);
      },
      error: (error) => {
        console.error('Error sending message to event bus:', error);
      }
    });
  }
  onExternalService(): void {
    const url = this.externalServiceURL.value!;
    this.dhrService.vertxExternalService(url).subscribe({
      next: (response) => {
        console.log('External service response:', response);
        this.externalServiceResource.set(response);
      },
      error: (error) => {
        console.error('Error calling external service:', error);
      }
    });
  }
}
